import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { IGlobalTestimonials } from 'src/app/core/domain/public.models';

// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination, SwiperOptions } from "swiper";
// install Swiper modules
SwiperCore.use([Autoplay, Pagination]);

@Component({
  selector: 'app-banner-swiper-slider',
  templateUrl: './banner-swiper-slider.component.html',
  styleUrls: ['../slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BannerSwiperSliderComponent implements OnInit {
  @Input() globalTestimonialsList: IGlobalTestimonials[];
  public config: SwiperOptions = {};
  constructor() { }

  ngOnInit(): void {
    this.config = {
      autoplay: {
        delay: 10000,
        disableOnInteraction: false
      },
      pagination: { clickable: true, dynamicBullets: true, dynamicMainBullets: 1 },
      breakpoints: {
        // when window width is >= 320px
        320: {
          noSwipingClass: '',
          noSwiping: false,
          longSwipes: false,
          shortSwipes: true,
          noSwipingSelector: ''
        },
        // when window width is >= 480px
        480: {
          noSwipingClass: '',
          noSwiping: false,
          longSwipes: false,
          shortSwipes: true,
          noSwipingSelector: ''
        },
        // when window width is >= 640px
        640: {
          noSwipingClass: 'swiper-no-swiping',
          noSwiping: true,
          longSwipes: false,
          shortSwipes: false,
          noSwipingSelector: 'swiper',
        }
      }
    }
  }

}
